class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();
    this.initTwoStepSearch();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  initTwoStepSearch() {
    // Handle the two-step search functionality
    const initialSearch = document.getElementById('search-initial');
    const searchResults = document.getElementById('search-results');
    const initialForm = document.querySelector('.search-initial-form');

    // If we have search results, hide initial state
    if (searchResults && searchResults.classList.contains('visible')) {
      if (initialSearch) {
        initialSearch.style.display = 'none';
      }
    }

    // Handle initial search form submission
    if (initialForm) {
      initialForm.addEventListener('submit', function (e) {
        const input = this.querySelector('input[name="q"]');
        if (!input.value.trim()) {
          e.preventDefault();
          return;
        }
        // Form will submit normally and redirect to search results
      });
    }
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);

// Standalone Placeholder Animation for Initial Search Input
(function () {
  let animationRunning = false;
  let animationInterval = null;

  function initPlaceholderAnimation() {
    // Find the initial search input
    const initialSearchInput = document.querySelector('.search-initial-input');
    const customCursorElement = document.getElementById('custom-cursor');

    if (!initialSearchInput) {
      return;
    }

    const placeholderText = initialSearchInput.getAttribute('data-placeholder') || initialSearchInput.getAttribute('placeholder') || 'What are you looking for?';
    const cursor = '|'; // Blinking cursor character
    let currentIndex = 0;
    let showCursor = true;
    let cursorInterval = null;
    let isTyping = false;
    let userIsTyping = false; // Track if user has started typing
    let emptyInputTimeout = null; // Timeout for restarting animation when input is empty
    animationRunning = true;

    // Clear placeholder initially
    initialSearchInput.setAttribute('placeholder', '');

    // Function to position cursor after text
    const positionCursor = () => {
      if (!customCursorElement || !initialSearchInput.value) return;

      // Create a temporary canvas to measure text width
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const computedStyle = window.getComputedStyle(initialSearchInput);
      context.font = computedStyle.font || `${computedStyle.fontSize} ${computedStyle.fontFamily}`;

      const textWidth = context.measureText(initialSearchInput.value).width;

      // Position cursor right after the text
      customCursorElement.style.left = `calc(50% + ${textWidth / 2}px + 10px)`;
      customCursorElement.style.display = 'block';
    };

    // Update the placeholder display
    const updatePlaceholder = () => {
      if (!animationRunning) return;
      const currentText = placeholderText.substring(0, currentIndex);
      initialSearchInput.setAttribute('placeholder', currentText + (showCursor ? cursor : ' '));
    };

    // Start cursor blinking (only when not typing)
    const startCursorBlink = () => {
      if (cursorInterval) clearInterval(cursorInterval);
      cursorInterval = setInterval(() => {
        if (!isTyping && !userIsTyping) {
          showCursor = !showCursor;
          updatePlaceholder();
        }
      }, 530); // Cursor blinks every 530ms
    };

    // Stop animation when user starts typing
    const stopAnimation = () => {
      if (animationRunning) {
        animationRunning = false;
        if (animationInterval) {
          clearInterval(animationInterval);
          animationInterval = null;
        }
        if (cursorInterval) {
          clearInterval(cursorInterval);
          cursorInterval = null;
        }
        initialSearchInput.setAttribute('placeholder', '');
      }
    };

    // Restart the animation from scratch
    const restartAnimation = () => {
      // Stop any existing animation
      stopAnimation();

      // Reset all variables
      currentIndex = 0;
      showCursor = true;
      isTyping = false;
      userIsTyping = false;
      animationRunning = true;

      // Clear placeholder
      initialSearchInput.setAttribute('placeholder', '');

      // Hide custom cursor
      if (customCursorElement) {
        customCursorElement.style.display = 'none';
      }

      // Start cursor blinking
      startCursorBlink();

      // Start animation after a short delay
      setTimeout(() => {
        if (animationRunning) {
          animationInterval = setInterval(animatePlaceholder, 100);
        }
      }, 500);
    };

    // Function to position custom cursor at caret position
    const updateCustomCursorPosition = () => {
      if (!customCursorElement || !initialSearchInput.value) {
        if (customCursorElement) customCursorElement.style.display = 'none';
        return;
      }

      const selectionStart = initialSearchInput.selectionStart;
      const textBeforeCursor = initialSearchInput.value.substring(0, selectionStart);

      // Create a temporary canvas to measure text width
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      const computedStyle = window.getComputedStyle(initialSearchInput);
      context.font = computedStyle.font || `${computedStyle.fontSize} ${computedStyle.fontFamily}`;

      const textWidth = context.measureText(textBeforeCursor).width;

      // Position cursor at the caret position
      customCursorElement.style.left = `calc(50% - ${context.measureText(initialSearchInput.value).width / 2}px + ${textWidth}px)`;
      customCursorElement.style.display = 'block';
    };

    // Add event listener to handle user input
    initialSearchInput.addEventListener('input', () => {
      const submitWrapper = document.getElementById('search-submit-wrapper');

      // Clear any existing timeout
      if (emptyInputTimeout) {
        clearTimeout(emptyInputTimeout);
        emptyInputTimeout = null;
      }

      if (initialSearchInput.value.length > 0) {
        userIsTyping = true;
        stopAnimation();
        // Show and position the custom cursor
        updateCustomCursorPosition();
        // Show submit button when user types first letter
        if (submitWrapper) {
          submitWrapper.style.display = 'flex';
        }
      } else {
        userIsTyping = false;
        if (customCursorElement) {
          customCursorElement.style.display = 'none';
        }
        // Hide submit button when input is empty
        if (submitWrapper) {
          submitWrapper.style.display = 'none';
        }

        // Start a 2-second timeout to restart animation if input stays empty
        emptyInputTimeout = setTimeout(() => {
          if (initialSearchInput.value.length === 0 && !animationRunning) {
            restartAnimation();
          }
        }, 2000);
      }
    });

    // Handle click on input - stop animation and focus
    initialSearchInput.addEventListener('click', () => {
      // Stop the animation when user clicks on input
      if (animationRunning) {
        userIsTyping = true;
        stopAnimation();
      }

      // Show the blinking cursor
      if (customCursorElement) {
        if (initialSearchInput.value.length > 0) {
          // Update cursor position if there's text
          updateCustomCursorPosition();
        } else {
          // Show cursor at center when input is empty
          customCursorElement.style.left = '50%';
          customCursorElement.style.transform = 'translate(-50%, -50%)';
          customCursorElement.style.display = 'block';
        }
      }

      // Ensure input is focused
      initialSearchInput.focus();
    });

    // Update cursor position on keyup and focus
    ['keyup', 'focus'].forEach(eventType => {
      initialSearchInput.addEventListener(eventType, () => {
        if (initialSearchInput.value.length > 0 && userIsTyping) {
          updateCustomCursorPosition();
        }
      });
    });

    // Clicking anywhere in the search-initial container should focus the input
    const searchInitialContainer = document.getElementById('search-initial');
    if (searchInitialContainer) {
      searchInitialContainer.addEventListener('click', (e) => {
        // Only trigger if clicking on the container itself, not the input
        // (input already has its own handler)
        if (e.target !== initialSearchInput) {
          // If input is empty, restart the animation
          if (initialSearchInput.value.length === 0) {
            restartAnimation();
          } else {
            // If there's text, stop animation and show cursor
            if (animationRunning) {
              userIsTyping = true;
              stopAnimation();
            }
          }

          // Focus the input
          initialSearchInput.focus();
        }
      });
    }

    // Animate placeholder text one letter at a time
    const animatePlaceholder = () => {
      if (!animationRunning) return;

      if (currentIndex < placeholderText.length) {
        isTyping = true;
        showCursor = true; // Always show cursor while typing
        currentIndex++;
        updatePlaceholder();
      } else {
        // Animation complete - pause then restart the loop
        isTyping = false;
        clearInterval(animationInterval);
        animationInterval = null;

        setTimeout(() => {
          if (animationRunning) {
            // Reset for next loop
            currentIndex = 0;
            showCursor = true;
            updatePlaceholder();

            // Restart typing animation
            setTimeout(() => {
              if (animationRunning) {
                animationInterval = setInterval(animatePlaceholder, 100);
              }
            }, 500);
          }
        }, 2000); // 2 second pause before restarting
      }
    };

    // Start cursor blinking
    startCursorBlink();

    // Start animation after a short delay
    setTimeout(() => {
      if (animationRunning) {
        animationInterval = setInterval(animatePlaceholder, 100); // 100ms per letter
      }
    }, 500); // 500ms initial delay
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlaceholderAnimation);
  } else {
    // DOM already loaded
    initPlaceholderAnimation();
  }
})();
